import { render, staticRenderFns } from "./AgentPage.vue?vue&type=template&id=48d5fce5&scoped=true"
import script from "./AgentPage.vue?vue&type=script&lang=js"
export * from "./AgentPage.vue?vue&type=script&lang=js"
import style0 from "./AgentPage.vue?vue&type=style&index=0&id=48d5fce5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48d5fce5",
  null
  
)

export default component.exports